import { Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: 'app-modal-set-price',
  template: `
    <ng-template #modalSetPrice let-modal>
      <div class="modal-header">
        <h5 class="modal-title">Precio por litro</h5>
        <button type="button" (click)="dismiss()" data-dismiss="modal" aria-label="Close" class="btn btn-link text-dark">
          <fa-icon [icon]="icons.faTimes"></fa-icon>
        </button>
      </div>
      <div class="modal-body p-4">
        <form [formGroup]="formPrice">
          <div class="form-group">
            <label for="price" class="form-label">Precio</label>
            <input type="number" class="form-control rounded-3" formControlName="price">
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-zazz-dark" (click)="saveData()">Guardar</button>
      </div>
    </ng-template>
  `,
  styleUrls: []
})
export class ModalSetPriceComponent implements OnInit {
  @Input() refuelList: any[] = [];
  @Output() priceData = new EventEmitter<any>();
  @Output() updateDismiss: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('modalSetPrice') modalSetPrice !: ElementRef;

  private modalRef: NgbModalRef | undefined;

  formPrice: FormGroup = new FormGroup({});

  constructor(
    private modalService: NgbModal,
    private fb: FormBuilder,
    private toastr: ToastrService,
    public icons: IconsService
  ) { }

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.formPrice = this.fb.group({
      price: ['']
    });
  }

  saveData() {
    this.priceData.emit(this.formPrice.value);
  }

  openModal(modalContent: TemplateRef<any>) {
    this.modalRef = this.modalService.open(modalContent);
  }

  dismiss() {
    if (this.modalRef) {
      this.updateDismiss.emit();
      this.modalRef.dismiss();
    }
  }

  
}
